var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.009 0.163939C11.8724 0.057385 11.7042 -0.000488281 11.531 -0.000488281C11.3578 -0.000488281 11.1896 0.057385 11.053 0.163939L0 8.78394L0.956 9.99294L2.308 8.93894V18.4609C2.30879 18.8687 2.47105 19.2595 2.75928 19.5479C3.04751 19.8364 3.43825 19.9989 3.846 19.9999H19.231C19.6387 19.9991 20.0294 19.8369 20.3177 19.5486C20.6059 19.2603 20.7682 18.8696 20.769 18.4619V8.94594L22.121 9.99994L23.077 8.79094L12.009 0.163939ZM13.076 18.4639H10V12.3079H13.077L13.076 18.4639ZM14.614 18.4639V12.3079C14.6135 11.9002 14.4513 11.5093 14.1629 11.221C13.8746 10.9327 13.4837 10.7705 13.076 10.7699H10C9.59226 10.7705 9.20137 10.9327 8.91305 11.221C8.62474 11.5093 8.46253 11.9002 8.462 12.3079V18.4619H3.846V7.73994L11.538 1.74794L19.23 7.74794V18.4619L14.614 18.4639Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardImage);
export default __webpack_public_path__ + "static/media/DashboardImage.c5f973fa41f0b68cace4b96bf6f70e81.svg";
export { ForwardRef as ReactComponent };